import {FC} from 'react'
import {format} from 'date-fns';
import { Timestamp } from "@firebase/firestore-types";

type Props = {
    value?: string
    className? : string
}

const CellString: FC<Props> = ({value, className}) => { 
  let valueStr: string = value ?? " - ";
  return (
    <div className={className??""}>{valueStr}</div>
  )
}

export default CellString
